// components/VariantsSection.tsx
import React from "react";
import Row from "@components/row";
import Fields from "@components/fields";
import FieldWrapper from "@components/wrapper/field-wrapper";
import Typography from "@components/typography";
import { VariantPreview } from "./VariantPreview";
import { VariantGenerator } from "./VariantGenerator";
import { VariantTable } from "./VariantTable";

interface VariantsSectionProps {
  values: any;
  setFieldValue: (field: string, value: any) => void;
  selectedColors: any[];
  selectedAttributes: any[];
  variantError: string;
  setVariantError: (error: string) => void;
  setSelectedAttributes: (attributes: any[]) => void;
  setSelectedColors: (colors: any[]) => void;
  fetchSingleAttribute: (id: string) => void;
  fetchSingleColor: (id: string) => void;
  attributes: any[];
  colors: any[];
  productData: any;
  isMobile: boolean;
}

export const VariantsSection: React.FC<VariantsSectionProps> = ({
  values,
  setFieldValue,
  selectedColors,
  selectedAttributes,
  variantError,
  setVariantError,
  setSelectedAttributes,
  setSelectedColors,
  fetchSingleAttribute,
  fetchSingleColor,
  attributes,
  colors,
  productData,
  isMobile,
}) => {
  return (
    <FieldWrapper>
      <Typography styleText="font-size:16px;font-weight:600;margin-bottom:10px">
        Variants
      </Typography>

      <span style={{ fontSize: "10px", color: "gray" }}>
        Color is optional, Use color for relevant products
      </span>
      <Row>
        <Fields.DropDown
          name="color"
          label="Color"
          placeholder="---select color---"
          options={colors?.filter(
            (color) => !selectedColors.some((sel) => sel.id === color.id),
          )}
          titleAsKey="name"
          valueAsKey="id"
          styleInput="width:96%"
          onChange={async (val) => {
            setFieldValue("color", val);
            await fetchSingleColor(val);
          }}
          styleOptionsWrapper="width:100%"
        />
        <Fields.DropDown
          name="attribute"
          label="Attributes"
          placeholder="---select Attributes---"
          options={attributes.filter(
            (attr) => !selectedAttributes.some((sel) => sel.id === attr.id),
          )}
          titleAsKey="name"
          valueAsKey="id"
          styleInput="width:96%"
          onChange={async (val) => {
            setFieldValue("attribute", val);
            await fetchSingleAttribute(val);
          }}
          styleOptionsWrapper="width:100%"
        />
      </Row>

      <br />

      <VariantPreview
        selectedColors={selectedColors}
        selectedAttributes={selectedAttributes}
        isMobile={isMobile}
        setSelectedAttributes={setSelectedAttributes}
        setSelectedColors={setSelectedColors}
      />

      <VariantGenerator
        values={values}
        setFieldValue={setFieldValue}
        selectedColors={selectedColors}
        selectedAttributes={selectedAttributes}
        variantError={variantError}
        setVariantError={setVariantError}
        productData={productData}
      />

      <VariantTable
        values={values}
        setFieldValue={setFieldValue}
        selectedColors={selectedColors}
        selectedAttributes={selectedAttributes}
        productData={productData}
      />
    </FieldWrapper>
  );
};
